import React from 'react';
import Header from './Header';
import faqs from '../json/faqs.json';
import { motion } from 'framer-motion';

// import useFirestore from '../hooks/useFirestore';

const parentVariant = {
	initial: {},
	animate: {
		transition: {
		},
	},
};

const faqVariant = {
	initial: {
	},
	animate: {
		height: 'auto',
		transition: {
		},
	},
};

function FAQs() {
	// const { docs } = useFirestore('faqs');
	return (
		<React.Fragment>
			<Header appTitle="FAQs" />
			<div className="main-body pd-md-v xl-pd-none">
				<motion.div variants={parentVariant} initial="initial" animate="animate" className="">
					{faqs.map((faq, index) => (
						<motion.div key={index} variants={faqVariant} className="each-faq sp-xl-bottom elevate ovf-hidden">
							<div className="header pd-md ln-bottom txt-primary font-bold">
								<b>{faq.question}</b>
							</div>
							<div className="body pd-md bg-light">{faq.answer}</div>
						</motion.div>
					))}
				</motion.div>
				<div className="pd-md-h blob-t blob-b txt-fade">Have something you want to know about me? Ask any question via the links I have provided in the contact section. You are advised to be formal when asking questions.</div>
			</div>
		</React.Fragment>
	);
}

export default FAQs;
